<div class="selection-panel-wrapper" *ngIf="isVisible" (click)="$event.stopPropagation()">
  <div class="selection-panel">
    <div class="selection-section">
      <div class="selection-title">{{ 'request_v2.category_form.selection_icon' | translate }}</div>

      <div class="icon-search-field">
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (click)="$event.stopPropagation()"
          placeholder="{{ 'request_v2.category_form.search_icon' | translate }}" />
      </div>

      <div class="icon-grid-list">
        <div
          class="icon-item"
          *ngFor="let icon of filteredIcons"
          (click)="onIconSelect(icon, $event)">
          <i
            [class]="icon"
            [class.selected]="selectedIcon === icon"></i>
        </div>
        <div class="icon-no-results" *ngIf="filteredIcons.length === 0">
          {{ 'request_v2.category_form.no_icon_results' | translate }}
        </div>
      </div>
    </div>
    
    <div class="selection-section">
      <div class="selection-title">{{ 'request_v2.category_form.selection_color' | translate }}</div>
      
      <div class="color-grid">
        <div *ngFor="let color of colors" 
             class="color-item" 
             [style.backgroundColor]="color"
             [class.selected]="selectedColor === color"
             (click)="onColorSelect(color, $event)">
        </div>
      </div>
    </div>
  </div>
</div>
